import { TBlogModuleHero } from '@/app/(blogposts)/blog/blog.types';
import { Typography } from '@/components/ui/Text';
import { assetUrl } from '@/lib/directus/assetUrl';
import Image from 'next/image';

import './BlogArticleModuleHeroMobile.scss';

type Props = {
  module: TBlogModuleHero;
};

export const BlogArticleModuleHeroMobile: React.FC<Props> = ({
  module: { heroImage, title, tag, textColor, overlayHEX },
}) => (
  <div className='BlogArticleModuleHeroMobile'>
    <div className='BlogArticleModuleHeroMobile__main-image-wrapper'>
      <Image
        src={assetUrl(heroImage) || ''}
        alt='hero'
        className='BlogArticleModuleHeroMobile__main-image'
        fill
      />

      {overlayHEX && (
        <div
          className='BlogArticleModuleHeroDesktop__main-image-overlay'
          style={{ backgroundColor: overlayHEX }}
        />
      )}
    </div>

    <div className='BlogArticleModuleHeroMobile__content'>
      {tag && (
        <div
          className='BlogArticleModuleHeroMobile__tag'
          style={{ color: textColor ? textColor : undefined }}
        >
          <Typography variant='body-small'>{tag}</Typography>
        </div>
      )}

      <div
        className='BlogArticleModuleHeroMobile__title'
        style={{ color: textColor ? textColor : undefined }}
      >
        <Typography variant='h1'>{title}</Typography>
      </div>
    </div>
  </div>
);
